// extracted by mini-css-extract-plugin
var _1 = "PreferencesSettings_cell__A3-U3";
var _2 = "PreferencesSettings_container__EyqA9";
var _3 = "PreferencesSettings_groupDescription__9-s6X";
var _4 = "PreferencesSettings_groupRow__f2RVs";
var _5 = "PreferencesSettings_requiresVerifiedEmail__kpnj+";
export { _1 as "cell", _2 as "container", _3 as "groupDescription", _4 as "groupRow", _5 as "requiresVerifiedEmail" }
